// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .content {
    position: relative;
} */

.main-content-part.small-content {
    max-height: 75vh;
    overflow: scroll;
}

.main-content-part.small-content .banner {
    width: 100%;
    height: 50vh;
    border-radius: 14px;
}

.main-content-part.small-content .titlePart {
    padding: 34px 0;
    border-bottom: 1px solid #EAEAEA;
}

.main-content-part.small-content .titlePart .title {
    font-style: normal;
    font-family: 'Poppins';
    text-align: left;
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0px;
    color: #1D2432;
    margin-bottom: 15px;
}

.main-content-part.small-content .titlePart .likeCount {
    display: flex;
    justify-content: space-between;
}

.main-content-part.small-content .titlePart .likeCount .textPart .text {
    font-style: normal;
    font-family: 'Poppins';
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    letter-spacing: 0px;
    color: #ADADAD;
}

.main-content-part.small-content .titlePart .likeCount .imagePart {
    display: flex;
    gap: 18px;
}

.main-content-part.small-content .titlePart .likeCount .imagePart .image {
    width: 28px;
    height: 25px;
}

.main-content-part.small-content .commentSection {
    padding: 21px 0;
}

.main-content-part.small-content .commentSection .heading {
    font-size: 20px;
    line-height: 40px;
    font-weight: 500;
    letter-spacing: 0px;
    color: #1D2432;
}

.main-content-part.small-content .commentSection .commentPart {
    display: flex;
    padding-top: 10px;
}

.main-content-part.small-content .commentSection .commentPart .profilePart {
    padding-right: 20px;
}

.main-content-part.small-content .commentSection .commentPart .profilePart .profile {
    width: 68px;
    height: 68px;
}

.main-content-part.small-content .commentSection .commentPart .textPart {
    width: 100%;
}

.main-content-part.small-content .commentSection .commentPart .textPart .name {
    font-weight: 500;
    line-height: 26px;
    font-size: 14px;
    letter-spacing: 0px;
    color: #1D2432;
}

.main-content-part.small-content .commentSection .commentPart .textPart .comment {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0px;
    color: #1D2432;
}

.main-content-part.small-content .commentSection .commentPart .textPart .bottomPart {
    display: flex;
    justify-content: space-between;
}

.main-content-part.small-content .commentSection .commentPart .textPart .bottomPart .leftPart {
    display: flex;
    gap: 30px;
    align-items: center;
}

.LikeReply {
    display: flex;
    gap: 30px;
    align-items: center;
}
/* Mobile devices (screens less than or equal to 768px) */
@media (max-width: 768px) {
    .main-content-part.small-content .commentSection .commentPart .textPart .bottomPart .leftPart {
        display: block;
    }
}

.main-content-part.small-content .commentSection .commentPart .textPart .bottomPart .leftPart .time {
    font-size: 14px;
    line-height: 27px;
    font-weight: 400;
    letter-spacing: 0px;
    color: #ADADAD;
}

.main-content-part.small-content .commentSection .commentPart .textPart .bottomPart .leftPart .LikeCount {
    font-size: 14px;
    line-height: 27px;
    font-weight: 400;
    letter-spacing: 0px;
    color: #1D2432;
}

.main-content-part.small-content .commentSection .commentPart .textPart .bottomPart .rightPart {
    display: flex;
    gap: 11px;
    align-items: center;
}

.main-content-part.small-content .commentSection .commentPart .textPart .bottomPart .rightPart .text {
    font-size: 14px;
    font-weight: unset !important;
    line-height: 28px;
    letter-spacing: 0px;
    color: #1D2432;
}

.main-content-part.small-content .commentSection .commentPart .textPart .bottomPart .rightPart .image {
    width: 25px;
    height: 22px;
}

.content .bottom-footer {
    position: fixed;
    bottom: 0;
    right: 0;
    display: flex;
    width: 100%;
    height: 120px;
    box-shadow: 0px 1px 15px #0000000f;
    padding: 31px 35px 31px 300px;
    background-color: #FFFFFF;
    display: flex;
    /* flex-wrap: wrap; */
    gap: 25px;
}
/* Mobile devices (screens less than or equal to 768px) */
@media (max-width: 768px) {
    .content .bottom-footer {
      padding: 30px; /* 30px padding for all sides */
    }
  }
.content .bottom-footer .leftPart {
    /* width: 60px; */
    display: flex;
    align-items: center;
}

.content .bottom-footer .leftPart .ProfileImg {
    width: 100%;
}

.content .bottom-footer .rightPart {
    width: 93%;
    display: flex;
    align-items: center;
}

.content .bottom-footer .rightPart .form {
    width: 100%;
    display: flex;
}

.content .bottom-footer .rightPart .form .send {
    width: 100%;
    padding: 16px 24px;
    border: 1px solid #EAEAEA;
    border-radius: 48px;
}
.content .bottom-footer .rightPart .form .sendButton{
    margin-left: -50px;
    position: relative;
    border: none;
    background-color: transparent;
}

@media (max-width: 768px) {
    .content .bottom-footer .rightPart .form .sendButton {
        margin-left: -40px; /* 30px padding for all sides */
    }
  }

.bottom-footerModal {
    position: relative;
    bottom: 0;
    right: 0;
    display: flex;
    width: 100%;
    height: 120px;
    /* box-shadow: 0px 1px 15px #0000000f; */
    padding: 31px 35px 31px 35px;
    background-color: #FFFFFF;
    display: flex;
    width: 100%;
    /* flex-wrap: wrap; */
    /* gap: 25px; */
}

.bottom-footerModal .leftPart {
    width: 60px;
    display: flex;
    align-items: center;
}

.bottom-footerModal .leftPart .ProfileImg {
    width: 100%;
}

.bottom-footerModal .rightPart {
    width: 100%;
    display: flex;
    align-items: center;
}

.bottom-footerModal .rightPart .form {
    width: 100%;
    display: flex;
}

.bottom-footerModal .rightPart .form .send {
    width: 100%;
    padding: 16px 24px;
    border: 1px solid #EAEAEA;
    border-radius: 48px;
}
.bottom-footerModal .rightPart .form .sendButton{
    margin-left: -50px;
    position: relative;
    border: none;
    background-color: transparent;
}   

@media (max-width: 768px) {
    .bottom-footerModal .rightPart .form .sendButton {
      margin-left: -40px; /* 30px padding for all sides */
    }
  }

.community-card-content > .image-part  , .community-card-content > .image-part >  img {
    border-top-right-radius: 14px;
    border-top-left-radius: 14px;
}


/* ruchi Blog inner started */

.blog-inner .blog-inner-page-section {
    display: flex;
    padding-top: 10px;
    padding-bottom: 81px;
    /* border-bottom: 1px solid #d9d9d9; */
  }
  .blog-inner .blog-inner-page-heading {
    font: 600 48px/60px Poppins, sans-serif;
    text-align: center;
  }
  .blog-inner  .blog-profile-content {
    display: flex;
    justify-content: center;
    padding: 1rem 0;
  }
  .blog-inner  .profile-image-containerblog {
    height: 44px;
    border-radius: 55%;

  }
  .blog-inner  .doctor-info-container {
    display: flex;
    gap: 18.5px;
    align-items: center;
    margin-left: 9px;
  }
  .blog-inner .doctor-info-card {
    margin: 0;
    font: 400 16px Poppins, sans-serif;
  }
  .blog-inner .vertical-divider {
    height: 22px;
    border-left: 1px solid black;
  }
  .blog-inner .blog-inner-page-content {
    display: flex;
    justify-content: center;
  }
  .blog-inner .blog-inner-page-content-container {
    max-width: 1000px;
  }
  .blog-inner .blog-inner-page-content-text-block {
    font: 400 16px/25.5px Poppins, sans-serif;
    color: rgba(0, 0, 0, 0.6);
  }
  .blog-inner .card-container {
    height: 514px;
    margin-top: 30px;
    background: #d9d9d9;
    border-radius: 12px;
  }
  
 
  
  @media screen and (max-width: 574px) {
    .blog-inner .blog-inner-page-heading {
      font-size: 24px;
      line-height: 40px;
    }
    .blog-inner .blog-inner-page-content{
      text-align: center;
    }
  }
  
/* ruchi Blog innner ended */`, "",{"version":3,"sources":["webpack://./src/assets/css/communityCard.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;AACA,yDAAyD;AACzD;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;IACR,aAAa;IACb,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,6BAA6B;IAC7B,yBAAyB;IACzB,aAAa;IACb,qBAAqB;IACrB,SAAS;AACb;AACA,yDAAyD;AACzD;IACI;MACE,aAAa,EAAE,+BAA+B;IAChD;EACF;AACF;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI;QACI,kBAAkB,EAAE,+BAA+B;IACvD;EACF;;AAEF;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,aAAa;IACb,WAAW;IACX,aAAa;IACb,wCAAwC;IACxC,4BAA4B;IAC5B,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI;MACE,kBAAkB,EAAE,+BAA+B;IACrD;EACF;;AAEF;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;;AAGA,6BAA6B;;AAE7B;IACI,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,sCAAsC;EACxC;EACA;IACE,uCAAuC;IACvC,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,kBAAkB;;EAEpB;EACA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,kCAAkC;EACpC;EACA;IACE,YAAY;IACZ,4BAA4B;EAC9B;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,yCAAyC;IACzC,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;EACrB;;;;EAIA;IACE;MACE,eAAe;MACf,iBAAiB;IACnB;IACA;MACE,kBAAkB;IACpB;EACF;;AAEF,4BAA4B","sourcesContent":["/* .content {\n    position: relative;\n} */\n\n.main-content-part.small-content {\n    max-height: 75vh;\n    overflow: scroll;\n}\n\n.main-content-part.small-content .banner {\n    width: 100%;\n    height: 50vh;\n    border-radius: 14px;\n}\n\n.main-content-part.small-content .titlePart {\n    padding: 34px 0;\n    border-bottom: 1px solid #EAEAEA;\n}\n\n.main-content-part.small-content .titlePart .title {\n    font-style: normal;\n    font-family: 'Poppins';\n    text-align: left;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 30px;\n    letter-spacing: 0px;\n    color: #1D2432;\n    margin-bottom: 15px;\n}\n\n.main-content-part.small-content .titlePart .likeCount {\n    display: flex;\n    justify-content: space-between;\n}\n\n.main-content-part.small-content .titlePart .likeCount .textPart .text {\n    font-style: normal;\n    font-family: 'Poppins';\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 20px;\n    letter-spacing: 0px;\n    color: #ADADAD;\n}\n\n.main-content-part.small-content .titlePart .likeCount .imagePart {\n    display: flex;\n    gap: 18px;\n}\n\n.main-content-part.small-content .titlePart .likeCount .imagePart .image {\n    width: 28px;\n    height: 25px;\n}\n\n.main-content-part.small-content .commentSection {\n    padding: 21px 0;\n}\n\n.main-content-part.small-content .commentSection .heading {\n    font-size: 20px;\n    line-height: 40px;\n    font-weight: 500;\n    letter-spacing: 0px;\n    color: #1D2432;\n}\n\n.main-content-part.small-content .commentSection .commentPart {\n    display: flex;\n    padding-top: 10px;\n}\n\n.main-content-part.small-content .commentSection .commentPart .profilePart {\n    padding-right: 20px;\n}\n\n.main-content-part.small-content .commentSection .commentPart .profilePart .profile {\n    width: 68px;\n    height: 68px;\n}\n\n.main-content-part.small-content .commentSection .commentPart .textPart {\n    width: 100%;\n}\n\n.main-content-part.small-content .commentSection .commentPart .textPart .name {\n    font-weight: 500;\n    line-height: 26px;\n    font-size: 14px;\n    letter-spacing: 0px;\n    color: #1D2432;\n}\n\n.main-content-part.small-content .commentSection .commentPart .textPart .comment {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 17px;\n    letter-spacing: 0px;\n    color: #1D2432;\n}\n\n.main-content-part.small-content .commentSection .commentPart .textPart .bottomPart {\n    display: flex;\n    justify-content: space-between;\n}\n\n.main-content-part.small-content .commentSection .commentPart .textPart .bottomPart .leftPart {\n    display: flex;\n    gap: 30px;\n    align-items: center;\n}\n\n.LikeReply {\n    display: flex;\n    gap: 30px;\n    align-items: center;\n}\n/* Mobile devices (screens less than or equal to 768px) */\n@media (max-width: 768px) {\n    .main-content-part.small-content .commentSection .commentPart .textPart .bottomPart .leftPart {\n        display: block;\n    }\n}\n\n.main-content-part.small-content .commentSection .commentPart .textPart .bottomPart .leftPart .time {\n    font-size: 14px;\n    line-height: 27px;\n    font-weight: 400;\n    letter-spacing: 0px;\n    color: #ADADAD;\n}\n\n.main-content-part.small-content .commentSection .commentPart .textPart .bottomPart .leftPart .LikeCount {\n    font-size: 14px;\n    line-height: 27px;\n    font-weight: 400;\n    letter-spacing: 0px;\n    color: #1D2432;\n}\n\n.main-content-part.small-content .commentSection .commentPart .textPart .bottomPart .rightPart {\n    display: flex;\n    gap: 11px;\n    align-items: center;\n}\n\n.main-content-part.small-content .commentSection .commentPart .textPart .bottomPart .rightPart .text {\n    font-size: 14px;\n    font-weight: unset !important;\n    line-height: 28px;\n    letter-spacing: 0px;\n    color: #1D2432;\n}\n\n.main-content-part.small-content .commentSection .commentPart .textPart .bottomPart .rightPart .image {\n    width: 25px;\n    height: 22px;\n}\n\n.content .bottom-footer {\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    display: flex;\n    width: 100%;\n    height: 120px;\n    box-shadow: 0px 1px 15px #0000000f;\n    padding: 31px 35px 31px 300px;\n    background-color: #FFFFFF;\n    display: flex;\n    /* flex-wrap: wrap; */\n    gap: 25px;\n}\n/* Mobile devices (screens less than or equal to 768px) */\n@media (max-width: 768px) {\n    .content .bottom-footer {\n      padding: 30px; /* 30px padding for all sides */\n    }\n  }\n.content .bottom-footer .leftPart {\n    /* width: 60px; */\n    display: flex;\n    align-items: center;\n}\n\n.content .bottom-footer .leftPart .ProfileImg {\n    width: 100%;\n}\n\n.content .bottom-footer .rightPart {\n    width: 93%;\n    display: flex;\n    align-items: center;\n}\n\n.content .bottom-footer .rightPart .form {\n    width: 100%;\n    display: flex;\n}\n\n.content .bottom-footer .rightPart .form .send {\n    width: 100%;\n    padding: 16px 24px;\n    border: 1px solid #EAEAEA;\n    border-radius: 48px;\n}\n.content .bottom-footer .rightPart .form .sendButton{\n    margin-left: -50px;\n    position: relative;\n    border: none;\n    background-color: transparent;\n}\n\n@media (max-width: 768px) {\n    .content .bottom-footer .rightPart .form .sendButton {\n        margin-left: -40px; /* 30px padding for all sides */\n    }\n  }\n\n.bottom-footerModal {\n    position: relative;\n    bottom: 0;\n    right: 0;\n    display: flex;\n    width: 100%;\n    height: 120px;\n    /* box-shadow: 0px 1px 15px #0000000f; */\n    padding: 31px 35px 31px 35px;\n    background-color: #FFFFFF;\n    display: flex;\n    width: 100%;\n    /* flex-wrap: wrap; */\n    /* gap: 25px; */\n}\n\n.bottom-footerModal .leftPart {\n    width: 60px;\n    display: flex;\n    align-items: center;\n}\n\n.bottom-footerModal .leftPart .ProfileImg {\n    width: 100%;\n}\n\n.bottom-footerModal .rightPart {\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.bottom-footerModal .rightPart .form {\n    width: 100%;\n    display: flex;\n}\n\n.bottom-footerModal .rightPart .form .send {\n    width: 100%;\n    padding: 16px 24px;\n    border: 1px solid #EAEAEA;\n    border-radius: 48px;\n}\n.bottom-footerModal .rightPart .form .sendButton{\n    margin-left: -50px;\n    position: relative;\n    border: none;\n    background-color: transparent;\n}   \n\n@media (max-width: 768px) {\n    .bottom-footerModal .rightPart .form .sendButton {\n      margin-left: -40px; /* 30px padding for all sides */\n    }\n  }\n\n.community-card-content > .image-part  , .community-card-content > .image-part >  img {\n    border-top-right-radius: 14px;\n    border-top-left-radius: 14px;\n}\n\n\n/* ruchi Blog inner started */\n\n.blog-inner .blog-inner-page-section {\n    display: flex;\n    padding-top: 10px;\n    padding-bottom: 81px;\n    /* border-bottom: 1px solid #d9d9d9; */\n  }\n  .blog-inner .blog-inner-page-heading {\n    font: 600 48px/60px Poppins, sans-serif;\n    text-align: center;\n  }\n  .blog-inner  .blog-profile-content {\n    display: flex;\n    justify-content: center;\n    padding: 1rem 0;\n  }\n  .blog-inner  .profile-image-containerblog {\n    height: 44px;\n    border-radius: 55%;\n\n  }\n  .blog-inner  .doctor-info-container {\n    display: flex;\n    gap: 18.5px;\n    align-items: center;\n    margin-left: 9px;\n  }\n  .blog-inner .doctor-info-card {\n    margin: 0;\n    font: 400 16px Poppins, sans-serif;\n  }\n  .blog-inner .vertical-divider {\n    height: 22px;\n    border-left: 1px solid black;\n  }\n  .blog-inner .blog-inner-page-content {\n    display: flex;\n    justify-content: center;\n  }\n  .blog-inner .blog-inner-page-content-container {\n    max-width: 1000px;\n  }\n  .blog-inner .blog-inner-page-content-text-block {\n    font: 400 16px/25.5px Poppins, sans-serif;\n    color: rgba(0, 0, 0, 0.6);\n  }\n  .blog-inner .card-container {\n    height: 514px;\n    margin-top: 30px;\n    background: #d9d9d9;\n    border-radius: 12px;\n  }\n  \n \n  \n  @media screen and (max-width: 574px) {\n    .blog-inner .blog-inner-page-heading {\n      font-size: 24px;\n      line-height: 40px;\n    }\n    .blog-inner .blog-inner-page-content{\n      text-align: center;\n    }\n  }\n  \n/* ruchi Blog innner ended */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
